function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.999.012C4.029.012 0 4.057 0 9.048a9.035 9.035 0 0 0 6.156 8.573c.45.083.614-.196.614-.435 0-.215-.008-.783-.012-1.537-2.503.546-3.032-1.212-3.032-1.212-.408-1.044-.999-1.321-.999-1.321-.818-.56.06-.55.06-.55.904.065 1.379.932 1.379.932.803 1.38 2.107.982 2.62.75.081-.583.314-.982.572-1.208-1.998-.228-4.1-1.003-4.1-4.465 0-.987.351-1.793.927-2.425-.093-.229-.402-1.148.088-2.391 0 0 .756-.243 2.475.926.717-.2 1.487-.3 2.253-.304a8.607 8.607 0 0 1 2.254.305c1.717-1.169 2.472-.926 2.472-.926.49 1.244.182 2.162.09 2.39.577.633.925 1.44.925 2.426 0 3.47-2.104 4.235-4.109 4.459.323.279.611.83.611 1.672 0 1.209-.01 2.183-.01 2.479 0 .242.161.523.618.434A9.036 9.036 0 0 0 18 9.048C18 4.058 13.97.012 8.999.012z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgGithubWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubWhite);
export default __webpack_public_path__ + "static/media/github-white.6a74f5ab.svg";
export { ForwardRef as ReactComponent };